export const resolvers = {
    ReferenceDataQueries: {
        accessorialServices: () => [
            {   enumValue: 'ACCELERATED',
                name: 'Accelerated',
            },
            {   enumValue: 'AIR_DEL',
                name: 'Air Delivery',
            },
            {   enumValue: 'AIR_PU',
                name: 'Air Pickup',
            },
            {   enumValue: 'APPT',
                name: 'Appointment',
            },
            {   enumValue: 'APPT_DEL',
                name: 'Delivery Appointment',
            },
            {   enumValue: 'APPT_PU',
                name: 'Pickup Appointment',
            },
            {   enumValue: 'ARCHR',
                name: 'ARCHR',
            },
            {   enumValue: 'BLIND',
                name: 'BLIND',
            },
            {   enumValue: 'CAMP_DEL',
                name: 'CAMP_DEL',
            },
            {   enumValue: 'CAMP_PU',
                name: 'CAMP_PU',
            },
            {   enumValue: 'CAN_FEE',
                name: 'CAN_FEE',
            },
            {   enumValue: 'CAP_LOAD',
                name: 'CAP_LOAD',
            },
            {   enumValue: 'CHNG_BOL',
                name: 'CHNG_BOL',
            },
            {   enumValue: 'CHRC_DEL',
                name: 'CHRC_DEL',
            },
            {   enumValue: 'CHRC_PU',
                name: 'CHRC_PU',
            },
            {   enumValue: 'CLUB_DEL',
                name: 'CLUB_DEL',
            },
            {   enumValue: 'CLUB_PU',
                name: 'CLUB_PU',
            },
            {   enumValue: 'CNV_DEL',
                name: 'CNV_DEL',
            },
            {   enumValue: 'CNV_PU',
                name: 'CNV_PU',
            },
            {   enumValue: 'COD',
                name: 'COD',
            },
            {   enumValue: 'CON_DEL',
                name: 'CON_DEL',
            },
            {   enumValue: 'CON_PU',
                name: 'CON_PU',
            },
            {   enumValue: 'CRE_DEL',
                name: 'CRE_DEL',
            },
            {   enumValue: 'DC_DEL',
                name: 'DC_DEL',
            },
            {   enumValue: 'DOCK_DEL',
                name: 'DOCK_DEL',
            },
            {   enumValue: 'DOCK_PU',
                name: 'DOCK_PU',
            },
            {   enumValue: 'DRAY',
                name: 'DRAY',
            },
            {   enumValue: 'EDU_DEL',
                name: 'EDU_DEL',
            },
            {   enumValue: 'EDU_PU',
                name: 'EDU_PU',
            },
            {   enumValue: 'ELS_10',
                name: 'ELS_10',
            },
            {   enumValue: 'ELS_11',
                name: 'ELS_11',
            },
            {   enumValue: 'ELS_12',
                name: 'ELS_12',
            },
            {   enumValue: 'ELS_13',
                name: 'ELS_13',
            },
            {   enumValue: 'ELS_14',
                name: 'ELS_14',
            },
            {   enumValue: 'ELS_15',
                name: 'ELS_15',
            },
            {   enumValue: 'ELS_16',
                name: 'ELS_16',
            },
            {   enumValue: 'ELS_17',
                name: 'ELS_17',
            },
            {   enumValue: 'ELS_18',
                name: 'ELS_18',
            },
            {   enumValue: 'ELS_19',
                name: 'ELS_19',
            },
            {   enumValue: 'ELS_20',
                name: 'ELS_20',
            },
            {   enumValue: 'ELS_21',
                name: 'ELS_21',
            },
            {   enumValue: 'ELS_22',
                name: 'ELS_22',
            },
            {   enumValue: 'ELS_23',
                name: 'ELS_23',
            },
            {   enumValue: 'ELS_24',
                name: 'ELS_24',
            },
            {   enumValue: 'ELS_25',
                name: 'ELS_25',
            },
            {   enumValue: 'ELS_26',
                name: 'ELS_26',
            },
            {   enumValue: 'ELS_27',
                name: 'ELS_27',
            },
            {   enumValue: 'ELS_28',
                name: 'ELS_28',
            },
            {   enumValue: 'ELS_29',
                name: 'ELS_29',
            },
            {   enumValue: 'ELS_30',
                name: 'ELS_30',
            },
            {   enumValue: 'ELS_8',
                name: 'ELS_8',
            },
            {   enumValue: 'ELS_9',
                name: 'ELS_9',
            },
            {   enumValue: 'EV',
                name: 'EV',
            },
            {   enumValue: 'EXPEDITE',
                name: 'Expedite',
            },
            {   enumValue: 'EXPEDITE_17',
                name: 'EXPEDITE_17',
            },
            {   enumValue: 'EXPEDITE_AM',
                name: 'EXPEDITE_AM',
            },
            {   enumValue: 'EXPORT',
                name: 'EXPORT',
            },
            {   enumValue: 'FARM_DEL',
                name: 'FARM_DEL',
            },
            {   enumValue: 'FARM_PU',
                name: 'FARM_PU',
            },
            {   enumValue: 'FRZABLE',
                name: 'FRZABLE',
            },
            {   enumValue: 'GOV_DEL',
                name: 'GOV_DEL',
            },
            {   enumValue: 'GRO_DEL',
                name: 'GRO_DEL',
            },
            {   enumValue: 'GRO_PU',
                name: 'GRO_PU',
            },
            {   enumValue: 'GS_10',
                name: 'GS_10',
            },
            {   enumValue: 'GS_11',
                name: 'GS_11',
            },
            {   enumValue: 'GS_14',
                name: 'GS_14',
            },
            {   enumValue: 'GS_15',
                name: 'GS_15',
            },
            {   enumValue: 'GS_1530',
                name: 'GS_1530',
            },
            {   enumValue: 'GS_8',
                name: 'GS_8',
            },
            {   enumValue: 'GS_9',
                name: 'GS_9',
            },
            {   enumValue: 'GS_AM',
                name: 'GS_AM',
            },
            {   enumValue: 'GS_MUL',
                name: 'GS_MUL',
            },
            {   enumValue: 'GUR',
                name: 'GUR',
            },
            {   enumValue: 'GUR_WIN',
                name: 'GUR_WIN',
            },
            {   enumValue: 'HAWAII',
                name: 'HAWAII',
            },
            {   enumValue: 'HAZM',
                name: 'HAZM',
            },
            {   enumValue: 'HOS_DEL',
                name: 'HOS_DEL',
            },
            {   enumValue: 'HOS_PU',
                name: 'HOS_PU',
            },
            {   enumValue: 'HOTL_DEL',
                name: 'HOTL_DEL',
            },
            {   enumValue: 'HOTL_PU',
                name: 'HOTL_PU',
            },
            {   enumValue: 'IMPORT',
                name: 'IMPORT',
            },
            {   enumValue: 'IN_DEL',
                name: 'IN_DEL',
            },
            {   enumValue: 'INE_DEL',
                name: 'INE_DEL',
            },
            {   enumValue: 'ING_DEL',
                name: 'ING_DEL',
            },
            {   enumValue: 'INNE_DEL',
                name: 'INNE_DEL',
            },
            {   enumValue: 'IN_PU',
                name: 'IN_PU',
            },
            {   enumValue: 'LG_DEL',
                name: 'LG_DEL',
            },
            {   enumValue: 'LG_PU',
                name: 'LG_PU',
            },
            {   enumValue: 'LTD_DEL',
                name: 'LTD_DEL',
            },
            {   enumValue: 'LTD_PU',
                name: 'LTD_PU',
            },
            {   enumValue: 'LUMPER',
                name: 'LUMPER',
            },
            {   enumValue: 'MAIN_TEMP',
                name: 'MAIN_TEMP',
            },
            {   enumValue: 'MALL_DEL',
                name: 'MALL_DEL',
            },
            {   enumValue: 'MALL_PU',
                name: 'MALL_PU',
            },
            {   enumValue: 'MARKING',
                name: 'MARKING',
            },
            {   enumValue: 'MIL_DEL',
                name: 'MIL_DEL',
            },
            {   enumValue: 'MIL_PU',
                name: 'MIL_PU',
            },
            {   enumValue: 'MINE_DEL',
                name: 'MINE_DEL',
            },
            {   enumValue: 'MINE_PU',
                name: 'MINE_PU',
            },
            {   enumValue: 'NAR_DEL',
                name: 'NAR_DEL',
            },
            {   enumValue: 'NAR_PU',
                name: 'NAR_PU',
            },
            {   enumValue: 'NB_DEL',
                name: 'NB_DEL',
            },
            {   enumValue: 'NC_DEL',
                name: 'NC_DEL',
            },
            {   enumValue: 'NOTIFY',
                name: 'NOTIFY',
            },
            {   enumValue: 'O_750_U_6',
                name: 'O_750_U_6',
            },
            {   enumValue: 'OV_DIM',
                name: 'OV_DIM',
            },
            {   enumValue: 'PARK_DEL',
                name: 'PARK_DEL',
            },
            {   enumValue: 'PARK_PU',
                name: 'PARK_PU',
            },
            {   enumValue: 'PFH',
                name: 'PFH',
            },
            {   enumValue: 'PFZ',
                name: 'PFZ',
            },
            {   enumValue: 'PIER_DEL',
                name: 'PIER_DEL',
            },
            {   enumValue: 'PIER_PU',
                name: 'PIER_PU',
            },
            {   enumValue: 'POISON',
                name: 'POISON',
            },
            {   enumValue: 'PRIS_DEL',
                name: 'PRIS_DEL',
            },
            {   enumValue: 'PRIS_PU',
                name: 'PRIS_PU',
            },
            {   enumValue: 'RECON',
                name: 'RECON',
            },
            {   enumValue: 'RES_DEL',
                name: 'RES_DEL',
            },
            {   enumValue: 'RES_PU',
                name: 'RES_PU',
            },
            {   enumValue: 'RSRT_DEL',
                name: 'RSRT_DEL',
            },
            {   enumValue: 'SAT_DEL',
                name: 'SAT_DEL',
            },
            {   enumValue: 'SAT_PU',
                name: 'SAT_PU',
            },
            {   enumValue: 'SEA_DOC',
                name: 'SEA_DOC',
            },
            {   enumValue: 'SING_SHIP',
                name: 'SING_SHIP',
            },
            {   enumValue: 'SORT_DEL',
                name: 'SORT_DEL',
            },
            {   enumValue: 'SORT_PU',
                name: 'SORT_PU',
            },
            {   enumValue: 'SSTOR_DEL',
                name: 'SSTOR_DEL',
            },
            {   enumValue: 'SSTOR_PU',
                name: 'SSTOR_PU',
            },
            {   enumValue: 'UNLOAD_DEL',
                name: 'UNLOAD_DEL',
            },
            {   enumValue: 'WE_DEL',
                name: 'WE_DEL',
            },
            {   enumValue: 'W_INSPC',
                name: 'W_INSPC',
            },
        ],

        accessorialServiceTypes: () => [
            {   enumValue: 'PICKUP',
                name: 'Pickup',
            },
            {   enumValue: 'DELIVERY',
                name: 'Delivery',
            },
            {   enumValue: 'SERVICE_LEVEL',
                name: 'Service Level',
            },
            {   enumValue: 'NON_SPECIFIC',
                name: 'Non-specific',
            },
        ],

        billTos: () => [
            {   enumValue: 'SHIPPER',
                name: 'Shipper',
            },
            {   enumValue: 'CONSIGNEE',
                name: 'Consignee',
            },
            {   enumValue: 'THIRD_PARTY',
                name: 'Third Party',
            },
        ],

        businessTypes: () => [
            {   enumValue: 'PRIMARY',
                name: 'Primary',
            },
            {   enumValue: 'SHIPPER',
                name: 'Shipper',
            },
            {   enumValue: 'CUSTOMER',
                name: 'Customer',
            },
            {   enumValue: 'CARRIER',
                name: 'Carrier',
            },
            {   enumValue: 'SUPPLIER',
                name: 'Supplier',
            },
            {   enumValue: 'BROKER',
                name: 'Broker',
            },
            {   enumValue: 'MANAGER',
                name: 'Manager',
            },
            {   enumValue: 'OTHER',
                name: 'Other',
            },
        ],

        carrierStatuses: () => [
            {   enumValue: 'SAVED',
                name: 'Saved',
            },
            {   enumValue: 'AVAILABLE',
                name: 'Available',
            },
            {   enumValue: 'SUSPENDED',
                name: 'Suspended',
            },
            {   enumValue: 'DISCONTINUED',
                name: 'Discontinued',
            },
        ],

        chargeCategories: () => [
            {   enumValue: 'FREIGHT',
                name: 'Freight',
            },
            {   enumValue: 'DISCOUNT',
                name: 'Discount',
            },
            {   enumValue: 'MINIMUM',
                name: 'Minimum',
            },
            {   enumValue: 'DEFICIT',
                name: 'Deficit',
            },
            {   enumValue: 'FUEL',
                name: 'Fuel',
            },
            {   enumValue: 'ACCESSORIAL',
                name: 'Accessorial',
            },
        ],

        chargeCodes: () => [
            {   enumValue: 'ACC',
                name: 'ACC',
            },
            {   enumValue: 'ACCELERATED',
                name: 'ACCELERATED',
            },
            {   enumValue: 'ADDL_CHRG',
                name: 'ADDL_CHRG',
            },
            {   enumValue: 'ADV_COL',
                name: 'ADV_COL',
            },
            {   enumValue: 'AFSC',
                name: 'AFSC',
            },
            {   enumValue: 'AFTR_HR',
                name: 'AFTR_HR',
            },
            {   enumValue: 'AFTR_HR_DEL',
                name: 'AFTR_HR_DEL',
            },
            {   enumValue: 'AIR',
                name: 'AIR',
            },
            {   enumValue: 'AIR_BAG',
                name: 'AIR_BAG',
            },
            {   enumValue: 'AIR_DEL',
                name: 'AIR_DEL',
            },
            {   enumValue: 'AIR_PU',
                name: 'AIR_PU',
            },
            {   enumValue: 'APPT',
                name: 'APPT',
            },
            {   enumValue: 'APPT_DEL',
                name: 'APPT_DEL',
            },
            {   enumValue: 'APPT_PU',
                name: 'APPT_PU',
            },
            {   enumValue: 'AR_CHR',
                name: 'AR_CHR',
            },
            {   enumValue: 'AS_WGHT',
                name: 'AS_WGHT',
            },
            {   enumValue: 'BAG_LINER',
                name: 'BAG_LINER',
            },
            {   enumValue: 'BLIND',
                name: 'BLIND',
            },
            {   enumValue: 'BOBTAIL',
                name: 'BOBTAIL',
            },
            {   enumValue: 'BOND',
                name: 'BOND',
            },
            {   enumValue: 'BORD_CROSS',
                name: 'BORD_CROSS',
            },
            {   enumValue: 'BULK_HEAD',
                name: 'BULK_HEAD',
            },
            {   enumValue: 'BYD_IND',
                name: 'BYD_IND',
            },
            {   enumValue: 'CAMP_DEL',
                name: 'CAMP_DEL',
            },
            {   enumValue: 'CAMP_PU',
                name: 'CAMP_PU',
            },
            {   enumValue: 'CAN_FEE',
                name: 'CAN_FEE',
            },
            {   enumValue: 'CAP_LOAD',
                name: 'CAP_LOAD',
            },
            {   enumValue: 'CAP_LOAD_PUP',
                name: 'CAP_LOAD_PUP',
            },
            {   enumValue: 'CAP_LOAD_TRA',
                name: 'CAP_LOAD_TRA',
            },
            {   enumValue: 'CARB_FEE_CARB',
                name: 'CARB_FEE_CARB',
            },
            {   enumValue: 'CERT',
                name: 'CERT',
            },
            {   enumValue: 'CERT_PU',
                name: 'CERT_PU',
            },
            {   enumValue: 'CHASSIS',
                name: 'CHASSIS',
            },
            {   enumValue: 'CHNG_BOL',
                name: 'CHNG_BOL',
            },
            {   enumValue: 'CHRC_DEL',
                name: 'CHRC_DEL',
            },
            {   enumValue: 'CHRC_PU',
                name: 'CHRC_PU',
            },
            {   enumValue: 'CLUB_DEL',
                name: 'CLUB_DEL',
            },
            {   enumValue: 'CLUB_PU',
                name: 'CLUB_PU',
            },
            {   enumValue: 'CNTER_20',
                name: 'CNTER_20',
            },
            {   enumValue: 'CNTER_40',
                name: 'CNTER_40',
            },
            {   enumValue: 'CNTER_40_H',
                name: 'CNTER_40_H',
            },
            {   enumValue: 'CNTER_45',
                name: 'CNTER_45',
            },
            {   enumValue: 'CNTER_53',
                name: 'CNTER_53',
            },
            {   enumValue: 'CNV',
                name: 'CNV',
            },
            {   enumValue: 'CNV_DEL',
                name: 'CNV_DEL',
            },
            {   enumValue: 'CNV_PU',
                name: 'CNV_PU',
            },
            {   enumValue: 'COD',
                name: 'COD',
            },
            {   enumValue: 'COM_DEL',
                name: 'COM_DEL',
            },
            {   enumValue: 'COM_PU',
                name: 'COM_PU',
            },
            {   enumValue: 'CON_DEL',
                name: 'CON_DEL',
            },
            {   enumValue: 'CON_PU',
                name: 'CON_PU',
            },
            {   enumValue: 'CONS',
                name: 'CONS',
            },
            {   enumValue: 'CONSOL',
                name: 'CONSOL',
            },
            {   enumValue: 'COR_BOL',
                name: 'COR_BOL',
            },
            {   enumValue: 'COR_FEE',
                name: 'COR_FEE',
            },
            {   enumValue: 'CRANE',
                name: 'CRANE',
            },
            {   enumValue: 'CRE_DEL',
                name: 'CRE_DEL',
            },
            {   enumValue: 'CROSS',
                name: 'CROSS',
            },
            {   enumValue: 'CUS_INBOND',
                name: 'CUS_INBOND',
            },
            {   enumValue: 'DC_DEL',
                name: 'DC_DEL',
            },
            {   enumValue: 'DEC_VAL',
                name: 'DEC_VAL',
            },
            {   enumValue: 'DEF',
                name: 'DEF',
            },
            {   enumValue: 'DEL_BY',
                name: 'DEL_BY',
            },
            {   enumValue: 'DEL_C',
                name: 'DEL_C',
            },
            {   enumValue: 'DEL_ON',
                name: 'DEL_ON',
            },
            {   enumValue: 'DESC_INS',
                name: 'DESC_INS',
            },
            {   enumValue: 'DET',
                name: 'DET',
            },
            {   enumValue: 'DIM_WGHT',
                name: 'DIM_WGHT',
            },
            {   enumValue: 'DLY_CHRG',
                name: 'DLY_CHRG',
            },
            {   enumValue: 'DOC_FEE',
                name: 'DOC_FEE',
            },
            {   enumValue: 'DOCK_DEL',
                name: 'DOCK_DEL',
            },
            {   enumValue: 'DOCK_PU',
                name: 'DOCK_PU',
            },
            {   enumValue: 'DR_ASST',
                name: 'DR_ASST',
            },
            {   enumValue: 'DRAY',
                name: 'DRAY',
            },
            {   enumValue: 'DROP_PULL',
                name: 'DROP_PULL',
            },
            {   enumValue: 'DRY_RUN',
                name: 'DRY_RUN',
            },
            {   enumValue: 'DSC',
                name: 'DSC',
            },
            {   enumValue: 'DVAL_DEL',
                name: 'DVAL_DEL',
            },
            {   enumValue: 'DVAL_PU',
                name: 'DVAL_PU',
            },
            {   enumValue: 'EDU',
                name: 'EDU',
            },
            {   enumValue: 'EDU_DEL',
                name: 'EDU_DEL',
            },
            {   enumValue: 'EDU_PU',
                name: 'EDU_PU',
            },
            {   enumValue: 'ELS',
                name: 'ELS',
            },
            {   enumValue: 'ELS_10',
                name: 'ELS_10',
            },
            {   enumValue: 'ELS_11',
                name: 'ELS_11',
            },
            {   enumValue: 'ELS_12',
                name: 'ELS_12',
            },
            {   enumValue: 'ELS_13',
                name: 'ELS_13',
            },
            {   enumValue: 'ELS_14',
                name: 'ELS_14',
            },
            {   enumValue: 'ELS_15',
                name: 'ELS_15',
            },
            {   enumValue: 'ELS_16',
                name: 'ELS_16',
            },
            {   enumValue: 'ELS_17',
                name: 'ELS_17',
            },
            {   enumValue: 'ELS_18',
                name: 'ELS_18',
            },
            {   enumValue: 'ELS_19',
                name: 'ELS_19',
            },
            {   enumValue: 'ELS_20',
                name: 'ELS_20',
            },
            {   enumValue: 'ELS_21',
                name: 'ELS_21',
            },
            {   enumValue: 'ELS_22',
                name: 'ELS_22',
            },
            {   enumValue: 'ELS_23',
                name: 'ELS_23',
            },
            {   enumValue: 'ELS_24',
                name: 'ELS_24',
            },
            {   enumValue: 'ELS_25',
                name: 'ELS_25',
            },
            {   enumValue: 'ELS_26',
                name: 'ELS_26',
            },
            {   enumValue: 'ELS_27',
                name: 'ELS_27',
            },
            {   enumValue: 'ELS_28',
                name: 'ELS_28',
            },
            {   enumValue: 'ELS_29',
                name: 'ELS_29',
            },
            {   enumValue: 'ELS_30',
                name: 'ELS_30',
            },
            {   enumValue: 'ELS_8',
                name: 'ELS_8',
            },
            {   enumValue: 'ELS_9',
                name: 'ELS_9',
            },
            {   enumValue: 'EMERGENCY_DEL',
                name: 'EMERGENCY_DEL',
            },
            {   enumValue: 'EV',
                name: 'EV',
            },
            {   enumValue: 'EXCHG',
                name: 'EXCHG',
            },
            {   enumValue: 'EX_LIAB',
                name: 'EX_LIAB',
            },
            {   enumValue: 'EXPEDITE',
                name: 'EXPEDITE',
            },
            {   enumValue: 'EXPEDITE_17',
                name: 'EXPEDITE_17',
            },
            {   enumValue: 'EXPEDITE_AM',
                name: 'EXPEDITE_AM',
            },
            {   enumValue: 'EXPORT',
                name: 'EXPORT',
            },
            {   enumValue: 'FARM',
                name: 'FARM',
            },
            {   enumValue: 'FARM_DEL',
                name: 'FARM_DEL',
            },
            {   enumValue: 'FARM_PU',
                name: 'FARM_PU',
            },
            {   enumValue: 'FBED_DEL',
                name: 'FBED_DEL',
            },
            {   enumValue: 'FBED_PU',
                name: 'FBED_PU',
            },
            {   enumValue: 'FERRY',
                name: 'FERRY',
            },
            {   enumValue: 'FINSUR',
                name: 'FINSUR',
            },
            {   enumValue: 'FLT_TRCK',
                name: 'FLT_TRCK',
            },
            {   enumValue: 'FOOD',
                name: 'FOOD',
            },
            {   enumValue: 'FORK',
                name: 'FORK',
            },
            {   enumValue: 'FRIDGE',
                name: 'FRIDGE',
            },
            {   enumValue: 'FRZABLE',
                name: 'FRZABLE',
            },
            {   enumValue: 'FSC',
                name: 'FSC',
            },
            {   enumValue: 'GFC',
                name: 'GFC',
            },
            {   enumValue: 'GOV',
                name: 'GOV',
            },
            {   enumValue: 'GOV_DEL',
                name: 'GOV_DEL',
            },
            {   enumValue: 'GOV_PU',
                name: 'GOV_PU',
            },
            {   enumValue: 'GRO',
                name: 'GRO',
            },
            {   enumValue: 'GRO_DEL',
                name: 'GRO_DEL',
            },
            {   enumValue: 'GRO_PU',
                name: 'GRO_PU',
            },
            {   enumValue: 'GS_10',
                name: 'GS_10',
            },
            {   enumValue: 'GS_11',
                name: 'GS_11',
            },
            {   enumValue: 'GS_14',
                name: 'GS_14',
            },
            {   enumValue: 'GS_15',
                name: 'GS_15',
            },
            {   enumValue: 'GS_1530',
                name: 'GS_1530',
            },
            {   enumValue: 'GS_8',
                name: 'GS_8',
            },
            {   enumValue: 'GS_9',
                name: 'GS_9',
            },
            {   enumValue: 'GS_AM',
                name: 'GS_AM',
            },
            {   enumValue: 'GSFM',
                name: 'GSFM',
            },
            {   enumValue: 'GS_MUL',
                name: 'GS_MUL',
            },
            {   enumValue: 'GS_SING',
                name: 'GS_SING',
            },
            {   enumValue: 'GST',
                name: 'GST',
            },
            {   enumValue: 'GUR',
                name: 'GUR',
            },
            {   enumValue: 'GUR_WIN',
                name: 'GUR_WIN',
            },
            {   enumValue: 'HAWAII',
                name: 'HAWAII',
            },
            {   enumValue: 'HAZM',
                name: 'HAZM',
            },
            {   enumValue: 'HC_D',
                name: 'HC_D',
            },
            {   enumValue: 'HC_P',
                name: 'HC_P',
            },
            {   enumValue: 'HC_SER',
                name: 'HC_SER',
            },
            {   enumValue: 'HDAY_DEL',
                name: 'HDAY_DEL',
            },
            {   enumValue: 'HDAY_PU',
                name: 'HDAY_PU',
            },
            {   enumValue: 'HEAT',
                name: 'HEAT',
            },
            {   enumValue: 'HIGH_DOCK',
                name: 'HIGH_DOCK',
            },
            {   enumValue: 'HM_LAND',
                name: 'HM_LAND',
            },
            {   enumValue: 'HOLI_WEEK',
                name: 'HOLI_WEEK',
            },
            {   enumValue: 'HOS_DEL',
                name: 'HOS_DEL',
            },
            {   enumValue: 'HOS_PU',
                name: 'HOS_PU',
            },
            {   enumValue: 'HOTL_DEL',
                name: 'HOTL_DEL',
            },
            {   enumValue: 'HOTL_PU',
                name: 'HOTL_PU',
            },
            {   enumValue: 'HST',
                name: 'HST',
            },
            {   enumValue: 'IMPORT',
                name: 'IMPORT',
            },
            {   enumValue: 'INBND',
                name: 'INBND',
            },
            {   enumValue: 'IN_DEL',
                name: 'IN_DEL',
            },
            {   enumValue: 'INE_DEL',
                name: 'INE_DEL',
            },
            {   enumValue: 'ING_DEL',
                name: 'ING_DEL',
            },
            {   enumValue: 'INNE_DEL',
                name: 'INNE_DEL',
            },
            {   enumValue: 'IN_PU',
                name: 'IN_PU',
            },
            {   enumValue: 'INS',
                name: 'INS',
            },
            {   enumValue: 'INT',
                name: 'INT',
            },
            {   enumValue: 'IREG',
                name: 'IREG',
            },
            {   enumValue: 'ITEM',
                name: 'ITEM',
            },
            {   enumValue: 'LABEL',
                name: 'LABEL',
            },
            {   enumValue: 'LG_DEL',
                name: 'LG_DEL',
            },
            {   enumValue: 'LG_PU',
                name: 'LG_PU',
            },
            {   enumValue: 'LG_SER',
                name: 'LG_SER',
            },
            {   enumValue: 'LH',
                name: 'LH',
            },
            {   enumValue: 'LIQUOR',
                name: 'LIQUOR',
            },
            {   enumValue: 'LOAD',
                name: 'LOAD',
            },
            {   enumValue: 'LOAD_CNT',
                name: 'LOAD_CNT',
            },
            {   enumValue: 'LOAD_UNLOAD',
                name: 'LOAD_UNLOAD',
            },
            {   enumValue: 'LTD_ACC',
                name: 'LTD_ACC',
            },
            {   enumValue: 'LTD_DEL',
                name: 'LTD_DEL',
            },
            {   enumValue: 'LTD_PU',
                name: 'LTD_PU',
            },
            {   enumValue: 'LUMPER',
                name: 'LUMPER',
            },
            {   enumValue: 'LYOVR',
                name: 'LYOVR',
            },
            {   enumValue: 'MAIN_TEMP',
                name: 'MAIN_TEMP',
            },
            {   enumValue: 'MALL',
                name: 'MALL',
            },
            {   enumValue: 'MALL_DEL',
                name: 'MALL_DEL',
            },
            {   enumValue: 'MALL_PU',
                name: 'MALL_PU',
            },
            {   enumValue: 'MARKING',
                name: 'MARKING',
            },
            {   enumValue: 'MIL_DEL',
                name: 'MIL_DEL',
            },
            {   enumValue: 'MIL_PU',
                name: 'MIL_PU',
            },
            {   enumValue: 'MIN',
                name: 'MIN',
            },
            {   enumValue: 'MINE_DEL',
                name: 'MINE_DEL',
            },
            {   enumValue: 'MINE_PU',
                name: 'MINE_PU',
            },
            {   enumValue: 'NAR_DEL',
                name: 'NAR_DEL',
            },
            {   enumValue: 'NAR_PU',
                name: 'NAR_PU',
            },
            {   enumValue: 'NB_DEL',
                name: 'NB_DEL',
            },
            {   enumValue: 'NB_PU',
                name: 'NB_PU',
            },
            {   enumValue: 'NC_DEL',
                name: 'NC_DEL',
            },
            {   enumValue: 'NC_PU',
                name: 'NC_PU',
            },
            {   enumValue: 'NC_SER',
                name: 'NC_SER',
            },
            {   enumValue: 'NFC',
                name: 'NFC',
            },
            {   enumValue: 'NOTIFY',
                name: 'NOTIFY',
            },
            {   enumValue: 'NURS_DEL',
                name: 'NURS_DEL',
            },
            {   enumValue: 'NURS_PU',
                name: 'NURS_PU',
            },
            {   enumValue: 'O_750_U_6',
                name: 'O_750_U_6',
            },
            {   enumValue: 'OCEAN',
                name: 'OCEAN',
            },
            {   enumValue: 'OFSC',
                name: 'OFSC',
            },
            {   enumValue: 'OIL_SANDS',
                name: 'OIL_SANDS',
            },
            {   enumValue: 'OPEN_TOP',
                name: 'OPEN_TOP',
            },
            {   enumValue: 'OV_DIM',
                name: 'OV_DIM',
            },
            {   enumValue: 'OVER_WGHT',
                name: 'OVER_WGHT',
            },
            {   enumValue: 'OVR_UNDR',
                name: 'OVR_UNDR',
            },
            {   enumValue: 'OVSZE_DEL',
                name: 'OVSZE_DEL',
            },
            {   enumValue: 'OVSZE_PU',
                name: 'OVSZE_PU',
            },
            {   enumValue: 'PALLET',
                name: 'PALLET',
            },
            {   enumValue: 'PAPER',
                name: 'PAPER',
            },
            {   enumValue: 'PARK_DEL',
                name: 'PARK_DEL',
            },
            {   enumValue: 'PARK_PU',
                name: 'PARK_PU',
            },
            {   enumValue: 'PFH',
                name: 'PFH',
            },
            {   enumValue: 'PFZ',
                name: 'PFZ',
            },
            {   enumValue: 'PFZ_C',
                name: 'PFZ_C',
            },
            {   enumValue: 'PIER_DEL',
                name: 'PIER_DEL',
            },
            {   enumValue: 'PIER_PU',
                name: 'PIER_PU',
            },
            {   enumValue: 'PJACK',
                name: 'PJACK',
            },
            {   enumValue: 'PJACK_DEL',
                name: 'PJACK_DEL',
            },
            {   enumValue: 'PJACK_PU',
                name: 'PJACK_PU',
            },
            {   enumValue: 'PKG_FEE',
                name: 'PKG_FEE',
            },
            {   enumValue: 'POISON',
                name: 'POISON',
            },
            {   enumValue: 'PORT_CON',
                name: 'PORT_CON',
            },
            {   enumValue: 'PRIS_DEL',
                name: 'PRIS_DEL',
            },
            {   enumValue: 'PRISON',
                name: 'PRISON',
            },
            {   enumValue: 'PRIS_PU',
                name: 'PRIS_PU',
            },
            {   enumValue: 'PRMIT',
                name: 'PRMIT',
            },
            {   enumValue: 'PROTECT',
                name: 'PROTECT',
            },
            {   enumValue: 'PROTECT_DRM',
                name: 'PROTECT_DRM',
            },
            {   enumValue: 'PROTECT_PAL',
                name: 'PROTECT_PAL',
            },
            {   enumValue: 'PST',
                name: 'PST',
            },
            {   enumValue: 'PUC',
                name: 'PUC',
            },
            {   enumValue: 'QST',
                name: 'QST',
            },
            {   enumValue: 'RECON',
                name: 'RECON',
            },
            {   enumValue: 'RE_DEL',
                name: 'RE_DEL',
            },
            {   enumValue: 'REEFER',
                name: 'REEFER',
            },
            {   enumValue: 'REG',
                name: 'REG',
            },
            {   enumValue: 'RES',
                name: 'RES',
            },
            {   enumValue: 'RES_DEL',
                name: 'RES_DEL',
            },
            {   enumValue: 'RES_PU',
                name: 'RES_PU',
            },
            {   enumValue: 'RMV_DEB',
                name: 'RMV_DEB',
            },
            {   enumValue: 'RSRT_DEL',
                name: 'RSRT_DEL',
            },
            {   enumValue: 'RSRT_PU',
                name: 'RSRT_PU',
            },
            {   enumValue: 'SAT_DEL',
                name: 'SAT_DEL',
            },
            {   enumValue: 'SAT_PU',
                name: 'SAT_PU',
            },
            {   enumValue: 'SEA_DOC',
                name: 'SEA_DOC',
            },
            {   enumValue: 'SEC_INS',
                name: 'SEC_INS',
            },
            {   enumValue: 'SHIP_DIV',
                name: 'SHIP_DIV',
            },
            {   enumValue: 'SIGN',
                name: 'SIGN',
            },
            {   enumValue: 'SING_SHIP',
                name: 'SING_SHIP',
            },
            {   enumValue: 'SORT',
                name: 'SORT',
            },
            {   enumValue: 'SORT_DEL',
                name: 'SORT_DEL',
            },
            {   enumValue: 'SORT_PU',
                name: 'SORT_PU',
            },
            {   enumValue: 'SPECIAL_EQUIP',
                name: 'SPECIAL_EQUIP',
            },
            {   enumValue: 'SSTOR_DEL',
                name: 'SSTOR_DEL',
            },
            {   enumValue: 'SSTOR_PU',
                name: 'SSTOR_PU',
            },
            {   enumValue: 'STD',
                name: 'STD',
            },
            {   enumValue: 'STORAGE',
                name: 'STORAGE',
            },
            {   enumValue: 'STP_OFF',
                name: 'STP_OFF',
            },
            {   enumValue: 'STRAIGHT',
                name: 'STRAIGHT',
            },
            {   enumValue: 'SUN_DEL',
                name: 'SUN_DEL',
            },
            {   enumValue: 'SUN_PU',
                name: 'SUN_PU',
            },
            {   enumValue: 'TANK',
                name: 'TANK',
            },
            {   enumValue: 'TARP',
                name: 'TARP',
            },
            {   enumValue: 'TAX',
                name: 'TAX',
            },
            {   enumValue: 'TCK_NU',
                name: 'TCK_NU',
            },
            {   enumValue: 'TM_CHG',
                name: 'TM_CHG',
            },
            {   enumValue: 'TOLL',
                name: 'TOLL',
            },
            {   enumValue: 'TPBOX_CHARGE',
                name: 'TPBOX_CHARGE',
            },
            {   enumValue: 'TPDEL_CHARGE',
                name: 'TPDEL_CHARGE',
            },
            {   enumValue: 'TRIAXLE',
                name: 'TRIAXLE',
            },
            {   enumValue: 'TSAC',
                name: 'TSAC',
            },
            {   enumValue: 'TWO_MAN',
                name: 'TWO_MAN',
            },
            {   enumValue: 'UNK_CHRG',
                name: 'UNK_CHRG',
            },
            {   enumValue: 'UNLOAD',
                name: 'UNLOAD',
            },
            {   enumValue: 'UNLOAD_CNT',
                name: 'UNLOAD_CNT',
            },
            {   enumValue: 'UNLOAD_DEL',
                name: 'UNLOAD_DEL',
            },
            {   enumValue: 'UNPCK',
                name: 'UNPCK',
            },
            {   enumValue: 'UTL',
                name: 'UTL',
            },
            {   enumValue: 'UTL_DEL',
                name: 'UTL_DEL',
            },
            {   enumValue: 'UTL_PU',
                name: 'UTL_PU',
            },
            {   enumValue: 'WE_DEL',
                name: 'WE_DEL',
            },
            {   enumValue: 'WE_PU',
                name: 'WE_PU',
            },
            {   enumValue: 'WE_SER',
                name: 'WE_SER',
            },
            {   enumValue: 'WGHT',
                name: 'WGHT',
            },
            {   enumValue: 'WGTV',
                name: 'WGTV',
            },
            {   enumValue: 'WHITE_GLOVE',
                name: 'WHITE_GLOVE',
            },
            {   enumValue: 'W_INSPC',
                name: 'W_INSPC',
            },
            {   enumValue: 'WIRE',
                name: 'WIRE',
            },
            {   enumValue: 'W_VERI',
                name: 'W_VERI',
            },
            {   enumValue: 'XCHG_DEL',
                name: 'XCHG_DEL',
            },
            {   enumValue: 'XCHG_PU',
                name: 'XCHG_PU',
            },
            {   enumValue: 'XFER_DEL',
                name: 'XFER_DEL',
            },
            {   enumValue: 'XFER_PU',
                name: 'XFER_PU',
            },
            {   enumValue: 'XTR_LBR',
                name: 'XTR_LBR',
            },
        ],

        checkDigitTypes: () => [
            {   enumValue: 'NONE',
                name: 'None',
            },
            {   enumValue: 'MOD_10',
                name: 'Mod10',
            },
            {   enumValue: 'MOD_7',
                name: 'Mod7',
            },
            {   enumValue: 'REDDAWAY',
                name: 'Reddaway',
            },
            {   enumValue: 'RNLO',
                name: 'RNLO',
            },
            {   enumValue: 'SEFL',
                name: 'SEFL',
            },
            {   enumValue: 'YRC',
                name: 'YRC',
            },
        ],

        contractClassifications: () => [
            {   enumValue: 'TEST',
                name: 'Test',
            },
            {   enumValue: 'LIVE',
                name: 'Live',
            },
            {   enumValue: 'INTERNAL',
                name: 'Internal',
            },
            {   enumValue: 'RFP',
                name: 'RFP',
            },
        ],

        country: () => [
            {   enumValue: 'US',
                name: 'United States of America',
            },
            {   enumValue: 'CA',
                name: 'Canada',
            },
            {   enumValue: 'MX',
                name: 'Mexico',
            },
        ],

        cultures: () => [
            {   enumValue: 'US_ENGLISH',
                name: 'English (United States)',
            },
        ],

        currencies: () => [
            {   enumValue: 'USD',
                name: 'United States Dollar',
            },
            {   enumValue: 'CAD',
                name: 'Canadian Dollar',
            },
            {   enumValue: 'MXN',
                name: 'Mexican Peso',
            },
        ],

        customFieldRequirementLevels: () => [
            {   enumValue: 'ERROR',
                name: 'Error',
            },
            {   enumValue: 'WARN',
                name: 'Warning',
            },
            {   enumValue: 'NONE',
                name: 'None',
            },
        ],

        customFieldSetTypes: () => [
            {   enumValue: 'SHIPMENT_REFERENCE',
                name: 'Shipment Reference',
            },
        ],

        customFieldTypes: () => [
            {   enumValue: 'TEXT',
                name: 'Text',
            },
            {   enumValue: 'DROP_DOWN',
                name: 'Drop-down',
            },
            {   enumValue: 'COMBO',
                name: 'Combo Box',
            },
        ],

        customFieldVisibilitys: () => [
            {   enumValue: 'SHOW',
                name: 'Show',
            },
            {   enumValue: 'SELECT',
                name: 'Select',
            },
            {   enumValue: 'HIDE',
                name: 'Hide',
            },
        ],

        defaultPaymentTerms: () => [
            {   enumValue: 'SET_BASED_ON_DIRECTION',
                name: 'Set Based on Direction',
            },
            {   enumValue: 'THIRD_PARTY',
                name: 'Third Party',
            },
        ],

        densityUnits: () => [
            {   enumValue: 'POUNDS_PER_CUBIC_FOOT',
                name: 'Pounds per Cubic Foot',
            },
            {   enumValue: 'KILOGRAMS_PER_CUBIC_METER',
                name: 'Kilograms per Cubic Meter',
            },
        ],

        dimensionUnits: () => [
            {   enumValue: 'INCHES',
                name: 'Inches',
            },
            {   enumValue: 'CENTIMETERS',
                name: 'Centimeters',
            },
            {   enumValue: 'FEET',
                name: 'Feet',
            },
            {   enumValue: 'METERS',
                name: 'Meters',
            },
        ],

        equipmentTypes: () => [
            {   enumValue: 'ET_20',
                name: 'ET_20',
            },
            {   enumValue: 'ET_2_B',
                name: 'ET_2_B',
            },
            {   enumValue: 'ET_2_D',
                name: 'ET_2_D',
            },
            {   enumValue: 'ET_2_E',
                name: 'ET_2_E',
            },
            {   enumValue: 'ET_2_F',
                name: 'ET_2_F',
            },
            {   enumValue: 'ET_2_G',
                name: 'ET_2_G',
            },
            {   enumValue: 'ET_40',
                name: 'ET_40',
            },
            {   enumValue: 'ET_4_B',
                name: 'ET_4_B',
            },
            {   enumValue: 'AC',
                name: 'AC',
            },
            {   enumValue: 'AF',
                name: 'AF',
            },
            {   enumValue: 'AL',
                name: 'AL',
            },
            {   enumValue: 'AP',
                name: 'AP',
            },
            {   enumValue: 'AT',
                name: 'AT',
            },
            {   enumValue: 'BC',
                name: 'BC',
            },
            {   enumValue: 'BE',
                name: 'BE',
            },
            {   enumValue: 'BF',
                name: 'BF',
            },
            {   enumValue: 'BG',
                name: 'BG',
            },
            {   enumValue: 'BH',
                name: 'BH',
            },
            {   enumValue: 'BJ',
                name: 'BJ',
            },
            {   enumValue: 'BK',
                name: 'BK',
            },
            {   enumValue: 'BO',
                name: 'BO',
            },
            {   enumValue: 'BR',
                name: 'BR',
            },
            {   enumValue: 'BX',
                name: 'BX',
            },
            {   enumValue: 'CA',
                name: 'CA',
            },
            {   enumValue: 'CB',
                name: 'CB',
            },
            {   enumValue: 'CC',
                name: 'CC',
            },
            {   enumValue: 'CD',
                name: 'CD',
            },
            {   enumValue: 'CG',
                name: 'CG',
            },
            {   enumValue: 'CH',
                name: 'CH',
            },
            {   enumValue: 'CI',
                name: 'CI',
            },
            {   enumValue: 'CJ',
                name: 'CJ',
            },
            {   enumValue: 'CK',
                name: 'CK',
            },
            {   enumValue: 'CL',
                name: 'CL',
            },
            {   enumValue: 'CM',
                name: 'CM',
            },
            {   enumValue: 'CN',
                name: 'CN',
            },
            {   enumValue: 'CP',
                name: 'CP',
            },
            {   enumValue: 'CQ',
                name: 'CQ',
            },
            {   enumValue: 'CR',
                name: 'CR',
            },
            {   enumValue: 'CS',
                name: 'CS',
            },
            {   enumValue: 'CT',
                name: 'CT',
            },
            {   enumValue: 'CU',
                name: 'CU',
            },
            {   enumValue: 'CV',
                name: 'CV',
            },
            {   enumValue: 'CW',
                name: 'CW',
            },
            {   enumValue: 'CX',
                name: 'CX',
            },
            {   enumValue: 'CZ',
                name: 'CZ',
            },
            {   enumValue: 'DD',
                name: 'DD',
            },
            {   enumValue: 'DF',
                name: 'DF',
            },
            {   enumValue: 'DT',
                name: 'DT',
            },
            {   enumValue: 'DX',
                name: 'DX',
            },
            {   enumValue: 'ET',
                name: 'ET',
            },
            {   enumValue: 'FF',
                name: 'FF',
            },
            {   enumValue: 'FH',
                name: 'FH',
            },
            {   enumValue: 'FN',
                name: 'FN',
            },
            {   enumValue: 'FP',
                name: 'FP',
            },
            {   enumValue: 'FR',
                name: 'FR',
            },
            {   enumValue: 'FS',
                name: 'FS',
            },
            {   enumValue: 'FT',
                name: 'FT',
            },
            {   enumValue: 'FX',
                name: 'FX',
            },
            {   enumValue: 'GS',
                name: 'GS',
            },
            {   enumValue: 'HB',
                name: 'HB',
            },
            {   enumValue: 'HC',
                name: 'HC',
            },
            {   enumValue: 'HO',
                name: 'HO',
            },
            {   enumValue: 'HP',
                name: 'HP',
            },
            {   enumValue: 'HT',
                name: 'HT',
            },
            {   enumValue: 'HV',
                name: 'HV',
            },
            {   enumValue: 'HY',
                name: 'HY',
            },
            {   enumValue: 'ID',
                name: 'ID',
            },
            {   enumValue: 'IX',
                name: 'IX',
            },
            {   enumValue: 'LO',
                name: 'LO',
            },
            {   enumValue: 'LS',
                name: 'LS',
            },
            {   enumValue: 'LU',
                name: 'LU',
            },
            {   enumValue: 'NX',
                name: 'NX',
            },
            {   enumValue: 'OB',
                name: 'OB',
            },
            {   enumValue: 'OT',
                name: 'OT',
            },
            {   enumValue: 'OV',
                name: 'OV',
            },
            {   enumValue: 'PL',
                name: 'PL',
            },
            {   enumValue: 'PP',
                name: 'PP',
            },
            {   enumValue: 'PT',
                name: 'PT',
            },
            {   enumValue: 'PU',
                name: 'PU',
            },
            {   enumValue: 'RA',
                name: 'RA',
            },
            {   enumValue: 'RC',
                name: 'RC',
            },
            {   enumValue: 'RD',
                name: 'RD',
            },
            {   enumValue: 'RE',
                name: 'RE',
            },
            {   enumValue: 'RF',
                name: 'RF',
            },
            {   enumValue: 'RG',
                name: 'RG',
            },
            {   enumValue: 'RI',
                name: 'RI',
            },
            {   enumValue: 'RO',
                name: 'RO',
            },
            {   enumValue: 'RR',
                name: 'RR',
            },
            {   enumValue: 'RS',
                name: 'RS',
            },
            {   enumValue: 'RT',
                name: 'RT',
            },
            {   enumValue: 'SA',
                name: 'SA',
            },
            {   enumValue: 'SC',
                name: 'SC',
            },
            {   enumValue: 'SD',
                name: 'SD',
            },
            {   enumValue: 'SK',
                name: 'SK',
            },
            {   enumValue: 'SL',
                name: 'SL',
            },
            {   enumValue: 'SR',
                name: 'SR',
            },
            {   enumValue: 'SS',
                name: 'SS',
            },
            {   enumValue: 'ST',
                name: 'ST',
            },
            {   enumValue: 'SV',
                name: 'SV',
            },
            {   enumValue: 'TA',
                name: 'TA',
            },
            {   enumValue: 'TB',
                name: 'TB',
            },
            {   enumValue: 'TC',
                name: 'TC',
            },
            {   enumValue: 'TF',
                name: 'TF',
            },
            {   enumValue: 'TG',
                name: 'TG',
            },
            {   enumValue: 'TH',
                name: 'TH',
            },
            {   enumValue: 'TI',
                name: 'TI',
            },
            {   enumValue: 'TJ',
                name: 'TJ',
            },
            {   enumValue: 'TK',
                name: 'TK',
            },
            {   enumValue: 'TL',
                name: 'TL',
            },
            {   enumValue: 'TM',
                name: 'TM',
            },
            {   enumValue: 'TN',
                name: 'TN',
            },
            {   enumValue: 'TO',
                name: 'TO',
            },
            {   enumValue: 'TP',
                name: 'TP',
            },
            {   enumValue: 'TQ',
                name: 'TQ',
            },
            {   enumValue: 'TR',
                name: 'TR',
            },
            {   enumValue: 'TT',
                name: 'TT',
            },
            {   enumValue: 'TU',
                name: 'TU',
            },
            {   enumValue: 'TV',
                name: 'TV',
            },
            {   enumValue: 'TW',
                name: 'TW',
            },
            {   enumValue: 'UA',
                name: 'UA',
            },
            {   enumValue: 'UB',
                name: 'UB',
            },
            {   enumValue: 'UC',
                name: 'UC',
            },
            {   enumValue: 'UD',
                name: 'UD',
            },
            {   enumValue: 'UE',
                name: 'UE',
            },
            {   enumValue: 'UL',
                name: 'UL',
            },
            {   enumValue: 'UP',
                name: 'UP',
            },
            {   enumValue: 'VA',
                name: 'VA',
            },
            {   enumValue: 'VE',
                name: 'VE',
            },
            {   enumValue: 'VL',
                name: 'VL',
            },
            {   enumValue: 'VR',
                name: 'VR',
            },
            {   enumValue: 'VS',
                name: 'VS',
            },
            {   enumValue: 'VT',
                name: 'VT',
            },
            {   enumValue: 'WR',
                name: 'WR',
            },
            {   enumValue: 'WY',
                name: 'WY',
            },
        ],

        featureFlags: () => [
            {   enumValue: 'SHIPMENT_INVOICE',
                name: 'Shipment Invoice',
            },
        ],

        filePurposes: () => [
            {   enumValue: 'SHIPMENT',
                name: 'Shipment',
            },
            {   enumValue: 'BRANDING',
                name: 'Branding',
            },
            {   enumValue: 'IMPORT',
                name: 'Import',
            },
            {   enumValue: 'EDI',
                name: 'EDI',
            },
            {   enumValue: 'OTHER',
                name: 'Other',
            },
        ],

        fileTypes: () => [
            {   enumValue: 'PDF',
                name: 'Document (PDF)',
            },
            {   enumValue: 'JPG',
                name: 'Image (JPEG)',
            },
            {   enumValue: 'PNG',
                name: 'Image (PNG)',
            },
            {   enumValue: 'GIF',
                name: 'Image (GIF)',
            },
            {   enumValue: 'TIF',
                name: 'Image (TIFF)',
            },
        ],

        freightClasses: () => [
            {   enumValue: 'CLASS_50',
                name: 'Class 50',
            },
            {   enumValue: 'CLASS_55',
                name: 'Class 55',
            },
            {   enumValue: 'CLASS_60',
                name: 'Class 60',
            },
            {   enumValue: 'CLASS_65',
                name: 'Class 65',
            },
            {   enumValue: 'CLASS_70',
                name: 'Class 70',
            },
            {   enumValue: 'CLASS_77_5',
                name: 'Class 77.5',
            },
            {   enumValue: 'CLASS_85',
                name: 'Class 85',
            },
            {   enumValue: 'CLASS_92_5',
                name: 'Class 92.5',
            },
            {   enumValue: 'CLASS_100',
                name: 'Class 100',
            },
            {   enumValue: 'CLASS_110',
                name: 'Class 110',
            },
            {   enumValue: 'CLASS_125',
                name: 'Class 125',
            },
            {   enumValue: 'CLASS_150',
                name: 'Class 150',
            },
            {   enumValue: 'CLASS_175',
                name: 'Class 175',
            },
            {   enumValue: 'CLASS_200',
                name: 'Class 200',
            },
            {   enumValue: 'CLASS_250',
                name: 'Class 250',
            },
            {   enumValue: 'CLASS_300',
                name: 'Class 300',
            },
            {   enumValue: 'CLASS_400',
                name: 'Class 400',
            },
            {   enumValue: 'CLASS_500',
                name: 'Class 500',
            },
        ],

        hazMatClasses: () => [
            {   enumValue: 'CLASS_1_1',
                name: '1.1 - Explosives - Mass Explosion Hazard',
            },
            {   enumValue: 'CLASS_1_2',
                name: '1.2 - Explosives - Projection Hazard',
            },
            {   enumValue: 'CLASS_1_3',
                name: '1.3 - Explosives - Fire w/ Minor Blast/Projection Hazard',
            },
            {   enumValue: 'CLASS_1_4',
                name: '1.4 - Explosives - Minor Explosion Hazard',
            },
            {   enumValue: 'CLASS_1_5',
                name: '1.5 - Explosives - Very Insensitive w/ Mass Explosion Hazard',
            },
            {   enumValue: 'CLASS_1_6',
                name: '1.6 - Explosives - Extremely Insensitive',
            },
            {   enumValue: 'CLASS_2_1',
                name: '2.1 - Gases - Flammable',
            },
            {   enumValue: 'CLASS_2_2',
                name: '2.2 - Gases - Nonflammable',
            },
            {   enumValue: 'CLASS_2_3',
                name: '2.3 - Gases - Toxic',
            },
            {   enumValue: 'CLASS_3',
                name: '3 - Flammable and Combustible Liquids',
            },
            {   enumValue: 'CLASS_4_1',
                name: '4.1 - Flammable Solids',
            },
            {   enumValue: 'CLASS_4_2',
                name: '4.2 - Flammable Solids - Spontaneously Combustible',
            },
            {   enumValue: 'CLASS_4_3',
                name: '4.3 - Flammable Solids - Dangerous When Wet',
            },
            {   enumValue: 'CLASS_5_1',
                name: '5.1 - Oxidizing Substances',
            },
            {   enumValue: 'CLASS_5_2',
                name: '5.2 - Organic Peroxides',
            },
            {   enumValue: 'CLASS_6_1',
                name: '6.1 - Toxic Substances',
            },
            {   enumValue: 'CLASS_6_2',
                name: '6.2 - Infectious Substances',
            },
            {   enumValue: 'CLASS_7',
                name: '7 - Radioactive Material',
            },
            {   enumValue: 'CLASS_8',
                name: '8 - Corrosives',
            },
            {   enumValue: 'CLASS_9',
                name: '9 - Miscellaneous Hazards',
            },
            {   enumValue: 'NONE',
                name: 'Not Hazardous',
            },
        ],

        hazMatPackingGroups: () => [
            {   enumValue: 'GREAT_DANGER',
                name: 'Great Danger',
            },
            {   enumValue: 'MEDIUM_DANGER',
                name: 'Medium Danger',
            },
            {   enumValue: 'MINOR_DANGER',
                name: 'Minor Danger',
            },
            {   enumValue: 'NONE',
                name: 'Not Hazardous',
            },
        ],

        invoiceStatuses: () => [
            {   enumValue: 'PROCESSED',
                name: 'Processed',
            },
            {   enumValue: 'READY_TO_REMIT',
                name: 'Ready to Remit',
            },
            {   enumValue: 'IN_REVIEW',
                name: 'In Review',
            },
            {   enumValue: 'DISPUTED',
                name: 'Disputed',
            },
            {   enumValue: 'AWAITING_REVISION',
                name: 'Awaiting Revision',
            },
            {   enumValue: 'AWAITING_REQUIREMENTS',
                name: 'Awaiting Requirements',
            },
            {   enumValue: 'REJECTED',
                name: 'Rejected',
            },
            {   enumValue: 'INCOMPLETE',
                name: 'Incomplete',
            },
        ],

        laneTypes: () => [
            {   enumValue: 'UNSPECIFIED',
                name: 'Unspecified',
            },
            {   enumValue: 'DIRECT',
                name: 'Direct',
            },
            {   enumValue: 'INDIRECT',
                name: 'Indirect',
            },
            {   enumValue: 'ALL',
                name: 'All',
            },
        ],

        netTermses: () => [
            {   enumValue: 'NET_0',
                name: 'Net 0',
            },
            {   enumValue: 'NET_15',
                name: 'Net 15',
            },
            {   enumValue: 'NET_30',
                name: 'Net 30',
            },
            {   enumValue: 'NET_60',
                name: 'Net 60',
            },
        ],

        notificationReasons: () => [
            {   enumValue: 'DIGEST',
                name: 'Digest',
            },
            {   enumValue: 'SHIPMENT_COMMENT_SAVED',
                name: 'Shipment Comment Saved',
            },
            {   enumValue: 'SHIPMENT_TENDER_FAILED',
                name: 'Shipment Tender Failed',
            },
            {   enumValue: 'SHIPMENT_TRACKING_LINK',
                name: 'Shipment Tracking Link',
            },
            {   enumValue: 'SHIPMENT_CANCELLED',
                name: 'Shipment Cancelled',
            },
            {   enumValue: 'EPRO_SEQUENCE_THRESHOLD_CROSSED',
                name: 'EPRO Source Threshold Crossed',
            },
            {   enumValue: 'SHIPMENT_INVOICE_COMMENT_SAVED',
                name: 'Shipment Invoice Comment Saved',
            },
            {   enumValue: 'SHIPMENT_TENDERED',
                name: 'Shipment Tendered',
            },
            {   enumValue: 'BILL_OF_LADING',
                name: 'Bill of Lading',
            },
            {   enumValue: 'SHIPPING_LABELS',
                name: 'Shipping Labels',
            },
            {   enumValue: 'CARRIER_ACCOUNT_CODE_NEEDED',
                name: 'Carrier Account Code Needed',
            },
        ],

        organizationTypes: () => [
            {   enumValue: 'STANDARD',
                name: 'Standard',
            },
            {   enumValue: 'DEMO',
                name: 'Demo',
            },
        ],

        orgUserRoles: () => [
            {   enumValue: 'ADMIN',
                name: 'Administrator',
            },
            {   enumValue: 'QUOTER',
                name: 'Quoter',
            },
            {   enumValue: 'SHIPPER',
                name: 'Shipper',
            },
        ],

        packageTypes: () => [
            {   enumValue: 'BAG',
                name: 'Bag',
            },
            {   enumValue: 'BALE',
                name: 'Bale',
            },
            {   enumValue: 'BOX',
                name: 'Box',
            },
            {   enumValue: 'BUCKET',
                name: 'Bucket',
            },
            {   enumValue: 'BUNDLE',
                name: 'Bundle',
            },
            {   enumValue: 'CAN',
                name: 'Can',
            },
            {   enumValue: 'CARTON',
                name: 'Carton',
            },
            {   enumValue: 'CASE',
                name: 'Case',
            },
            {   enumValue: 'COIL',
                name: 'Coil',
            },
            {   enumValue: 'CRATE',
                name: 'Crate',
            },
            {   enumValue: 'CYLINDER',
                name: 'Cylinder',
            },
            {   enumValue: 'DRUM',
                name: 'Drum',
            },
            {   enumValue: 'PAIL',
                name: 'Pail',
            },
            {   enumValue: 'PIECES',
                name: 'Pieces',
            },
            {   enumValue: 'PALLET',
                name: 'Pallet',
            },
            {   enumValue: 'REEL',
                name: 'Reel',
            },
            {   enumValue: 'ROLL',
                name: 'Roll',
            },
            {   enumValue: 'SKID',
                name: 'Skid',
            },
            {   enumValue: 'TUBE',
                name: 'Tube',
            },
            {   enumValue: 'NOT_APPLICABLE',
                name: 'Not Applicable',
            },
        ],

        parsingStatuses: () => [
            {   enumValue: 'NOT_PARSED',
                name: 'Not Parsed',
            },
            {   enumValue: 'WAITING_FOR_PARSING',
                name: 'Waiting for Parsing',
            },
            {   enumValue: 'PARSING',
                name: 'Parsing',
            },
            {   enumValue: 'PARSING_COMPLETE',
                name: 'Parsing Complete',
            },
            {   enumValue: 'PARSING_ERROR',
                name: 'Parsing Error',
            },
            {   enumValue: 'PARSING_FAILURE',
                name: 'Parsing Failure',
            },
        ],

        paymentTerms: () => [
            {   enumValue: 'PRE_PAID',
                name: 'Pre-paid',
            },
            {   enumValue: 'COLLECT',
                name: 'Collect',
            },
            {   enumValue: 'THIRD_PARTY',
                name: 'Third Party',
            },
        ],

        rateProviders: () => [
            {   enumValue: 'PROJECT_44',
                name: 'Project 44',
            },
            {   enumValue: 'DEMO',
                name: 'Demo',
            },
            {   enumValue: 'DUMMY',
                name: 'Dummy',
            },
        ],

        rateQualifiers: () => [
            {   enumValue: 'PER_100_WEIGHT',
                name: 'Per Hundredweight',
            },
            {   enumValue: 'FLAT_CHARGE',
                name: 'Flat Charge',
            },
            {   enumValue: 'PERCENTAGE_OF_FREIGHT',
                name: 'Percentage of Freight',
            },
            {   enumValue: 'PER_POUND',
                name: 'Per Pound',
            },
            {   enumValue: 'PER_MILE',
                name: 'Per Mile',
            },
            {   enumValue: 'PER_STOP',
                name: 'Per Stop',
            },
            {   enumValue: 'PER_EACH',
                name: 'Per Each',
            },
        ],

        serviceLevels: () => [
            {   enumValue: 'UNKNOWN',
                name: 'Unknown',
            },
            {   enumValue: 'ACCELERATED',
                name: 'Accelerated',
            },
            {   enumValue: 'CAPACITY_LOAD',
                name: 'Capacity Load',
            },
            {   enumValue: 'EXPEDITE',
                name: 'Expedite',
            },
            {   enumValue: 'EXPEDITE_BY_5_PM',
                name: 'Expedite by 5 PM',
            },
            {   enumValue: 'EXPEDITE_BY_NOON',
                name: 'Expedite by Noon',
            },
            {   enumValue: 'GUARANTEED_BY_10_AM',
                name: 'Guaranteed by 10:00 AM',
            },
            {   enumValue: 'GUARANTEED_BY_11_AM',
                name: 'Guaranteed by 11:00 AM',
            },
            {   enumValue: 'GUARANTEED_BY_2_PM',
                name: 'Guaranteed by 2:00 PM',
            },
            {   enumValue: 'GUARANTEED_BY_3_PM',
                name: 'Guaranteed by 3:00 PM',
            },
            {   enumValue: 'GUARANTEED_BY_330_PM',
                name: 'Guaranteed by 3:30 PM',
            },
            {   enumValue: 'GUARANTEED_BY_8_AM',
                name: 'Guaranteed by 8:00 AM',
            },
            {   enumValue: 'GUARANTEED_BY_9_AM',
                name: 'Guaranteed by 9:00 AM',
            },
            {   enumValue: 'GUARANTEED_BY_NOON',
                name: 'Guaranteed by Noon',
            },
            {   enumValue: 'GUARANTEED_FRIDAY_TO_MONDAY',
                name: 'Guaranteed Friday to Monday',
            },
            {   enumValue: 'GUARANTEED_MULTI_HOUR',
                name: 'Guaranteed Multi-Hour',
            },
            {   enumValue: 'GUARANTEED_SINGLE_HOUR',
                name: 'Guaranteed Single Hour',
            },
            {   enumValue: 'GUARANTEED',
                name: 'Guaranteed',
            },
            {   enumValue: 'GUARANTEED_IN_WINDOW',
                name: 'Guaranteed in Window',
            },
            {   enumValue: 'STANDARD',
                name: 'Standard',
            },
        ],

        shipmentDirections: () => [
            {   enumValue: 'OUTBOUND',
                name: 'Outbound',
            },
            {   enumValue: 'INBOUND',
                name: 'Inbound',
            },
            {   enumValue: 'DROP',
                name: 'Drop',
            },
            {   enumValue: 'SHUTTLE',
                name: 'Shuttle',
            },
        ],

        shipmentDocumentTypes: () => [
            {   enumValue: 'BOL',
                name: 'Bill of Lading',
            },
            {   enumValue: 'SIGNED_BOL',
                name: 'Signed Bill of Lading',
            },
            {   enumValue: 'PROOF_OF_DELIVERY',
                name: 'Proof of Delivery',
            },
            {   enumValue: 'PICKUP_RECEIPT',
                name: 'Pickup Receipt',
            },
            {   enumValue: 'INVOICE',
                name: 'Invoice',
            },
            {   enumValue: 'WEIGHT_CERTIFICATE',
                name: 'Weight Certificate',
            },
            {   enumValue: 'OTHER',
                name: 'Other',
            },
        ],

        shipmentInTransitStatuses: () => [
            {   enumValue: 'EARLY',
                name: 'Early',
            },
            {   enumValue: 'ON_TIME',
                name: 'On Time',
            },
            {   enumValue: 'OUT_FOR_DELIVERY',
                name: 'Out for Delivery',
            },
            {   enumValue: 'DELAYED',
                name: 'Delayed',
            },
        ],

        shipmentModes: () => [
            {   enumValue: 'LTL',
                name: 'LTL (Less than Truckload)',
            },
        ],

        shipmentStatuses: () => [
            {   enumValue: 'SAVED',
                name: 'Saved',
            },
            {   enumValue: 'AUTO_TENDERING',
                name: 'Auto-Tendering',
            },
            {   enumValue: 'READY_TO_TENDER',
                name: 'Ready to Tender',
            },
            {   enumValue: 'OPTIMIZING',
                name: 'Optimizing',
            },
            {   enumValue: 'TENDER_REQUESTED',
                name: 'Tender Requested',
            },
            {   enumValue: 'TENDER_REJECTED',
                name: 'Tender Rejected',
            },
            {   enumValue: 'AUTO_TENDER_TRANSIENT_FAILURE',
                name: 'Auto-Tender Transient Failure',
            },
            {   enumValue: 'AUTO_TENDER_PERMANENT_FAILURE',
                name: 'Auto-Tender Permanent Failure',
            },
            {   enumValue: 'WAITING_FOR_PICKUP',
                name: 'Waiting for Pickup',
            },
            {   enumValue: 'IN_TRANSIT',
                name: 'In Transit',
            },
            {   enumValue: 'DELIVERED',
                name: 'Delivered',
            },
            {   enumValue: 'CANCELLED',
                name: 'Cancelled',
            },
            {   enumValue: 'ABANDONED',
                name: 'Abandoned',
            },
            {   enumValue: 'EXCEPTION',
                name: 'Exception',
            },
        ],

        shipmentStopArrivals: () => [
            {   enumValue: 'UNKNOWN',
                name: 'Unknown',
            },
            {   enumValue: 'EARLY',
                name: 'Early',
            },
            {   enumValue: 'ON_TIME',
                name: 'On Time',
            },
            {   enumValue: 'LATE',
                name: 'Late',
            },
        ],

        shipmentStopStatuses: () => [
            {   enumValue: 'UNKNOWN',
                name: 'Unknown',
            },
            {   enumValue: 'EN_ROUTE',
                name: 'En Route',
            },
            {   enumValue: 'ARRIVED',
                name: 'Arrived',
            },
            {   enumValue: 'DEPARTED',
                name: 'Departed',
            },
        ],

        states: () => [
            // United States
            {   enumValue: 'AL',
                name: 'Alabama',
            },
            {   enumValue: 'AK',
                name: 'Alaska',
            },
            {   enumValue: 'AZ',
                name: 'Arizona',
            },
            {   enumValue: 'AR',
                name: 'Arkansas',
            },
            {   enumValue: 'CA',
                name: 'California',
            },
            {   enumValue: 'CO',
                name: 'Colorado',
            },
            {   enumValue: 'CT',
                name: 'Connecticut',
            },
            {   enumValue: 'DE',
                name: 'Delaware',
            },
            {   enumValue: 'FL',
                name: 'Florida',
            },
            {   enumValue: 'GA',
                name: 'Georgia',
            },
            {   enumValue: 'HI',
                name: 'Hawaii',
            },
            {   enumValue: 'ID',
                name: 'Idaho',
            },
            {   enumValue: 'IL',
                name: 'Illinois',
            },
            {   enumValue: 'IN',
                name: 'Indiana',
            },
            {   enumValue: 'IA',
                name: 'Iowa',
            },
            {   enumValue: 'KS',
                name: 'Kansas',
            },
            {   enumValue: 'KY',
                name: 'Kentucky',
            },
            {   enumValue: 'LA',
                name: 'Louisiana',
            },
            {   enumValue: 'ME',
                name: 'Maine',
            },
            {   enumValue: 'MD',
                name: 'Maryland',
            },
            {   enumValue: 'MA',
                name: 'Massachusetts',
            },
            {   enumValue: 'MI',
                name: 'Michigan',
            },
            {   enumValue: 'MN',
                name: 'Minnesota',
            },
            {   enumValue: 'MS',
                name: 'Mississippi',
            },
            {   enumValue: 'MO',
                name: 'Missouri',
            },
            {   enumValue: 'MT',
                name: 'Montana',
            },
            {   enumValue: 'NE',
                name: 'Nebraska',
            },
            {   enumValue: 'NV',
                name: 'Nevada',
            },
            {   enumValue: 'NH',
                name: 'New Hampshire',
            },
            {   enumValue: 'NJ',
                name: 'New Jersey',
            },
            {   enumValue: 'NM',
                name: 'New Mexico',
            },
            {   enumValue: 'NY',
                name: 'New York',
            },
            {   enumValue: 'NC',
                name: 'North Carolina',
            },
            {   enumValue: 'ND',
                name: 'North Dakota',
            },
            {   enumValue: 'OH',
                name: 'Ohio',
            },
            {   enumValue: 'OK',
                name: 'Oklahoma',
            },
            {   enumValue: 'OR',
                name: 'Oregon',
            },
            {   enumValue: 'PA',
                name: 'Pennsylvania',
            },
            {   enumValue: 'RI',
                name: 'Rhode Island',
            },
            {   enumValue: 'SC',
                name: 'South Carolina',
            },
            {   enumValue: 'SD',
                name: 'South Dakota',
            },
            {   enumValue: 'TN',
                name: 'Tennessee',
            },
            {   enumValue: 'TX',
                name: 'Texas',
            },
            {   enumValue: 'UT',
                name: 'Utah',
            },
            {   enumValue: 'VT',
                name: 'Vermont',
            },
            {   enumValue: 'VA',
                name: 'Virginia',
            },
            {   enumValue: 'WA',
                name: 'Washington',
            },
            {   enumValue: 'WV',
                name: 'West Virginia',
            },
            {   enumValue: 'WI',
                name: 'Wisconsin',
            },
            {   enumValue: 'WY',
                name: 'Wyomning',
            },
            {   enumValue: 'AS',
                name: 'Alaska',
            },
            {   enumValue: 'DC',
                name: 'District of Columbia',
            },
            {   enumValue: 'FM',
                name: 'Federated States of Micronesia',
            },
            {   enumValue: 'GU',
                name: 'Guam',
            },
            {   enumValue: 'MH',
                name: 'Marshall Islands',
            },
            {   enumValue: 'MP',
                name: 'Northern Mariana Islands',
            },
            {   enumValue: 'PW',
                name: 'Palau',
            },
            {   enumValue: 'PR',
                name: 'Puerto Rico',
            },
            {   enumValue: 'VI',
                name: 'US Virgin Islands',
            },

            // Canada
            {   enumValue: 'AB',
                name: 'Alberta',
            },
            {   enumValue: 'BC',
                name: 'British Columbia',
            },
            {   enumValue: 'MB',
                name: 'Manitoba',
            },
            {   enumValue: 'NB',
                name: 'New Brunswick',
            },
            {   enumValue: 'NL',
                name: 'Newfoundland and Labrador',
            },
            {   enumValue: 'NS',
                name: 'Nova Scotia',
            },
            {   enumValue: 'NT',
                name: 'Northwest Territories',
            },
            {   enumValue: 'NU',
                name: 'Nunavut',
            },
            {   enumValue: 'ON',
                name: 'Ontario',
            },
            {   enumValue: 'PE',
                name: 'Prince Edward Island',
            },
            {   enumValue: 'QC',
                name: 'Quebec',
            },
            {   enumValue: 'SK',
                name: 'Saskatchewan',
            },
            {   enumValue: 'YT',
                name: 'Yukon',
            },

            // Mexico
            {   enumValue: 'AGU',
                name: 'Aguascalientes',
            },
            {   enumValue: 'BCN',
                name: 'Baja California',
            },
            {   enumValue: 'BCS',
                name: 'Baja California Sur',
            },
            {   enumValue: 'CAM',
                name: 'Campeche',
            },
            {   enumValue: 'CHP',
                name: 'Chiapas',
            },
            {   enumValue: 'CHH',
                name: 'Chihuahua',
            },
            {   enumValue: 'COA',
                name: 'Coahuila',
            },
            {   enumValue: 'COL',
                name: 'Colima',
            },
            {   enumValue: 'CMX',
                name: 'Mexico City',
            },
            {   enumValue: 'DUR',
                name: 'Durango',
            },
            {   enumValue: 'GUA',
                name: 'Guanajuato',
            },
            {   enumValue: 'GRO',
                name: 'Guerrero',
            },
            {   enumValue: 'HID',
                name: 'Hidalgo',
            },
            {   enumValue: 'JAL',
                name: 'Jalisco',
            },
            {   enumValue: 'MEX',
                name: 'México',
            },
            {   enumValue: 'MIC',
                name: 'Michoacán',
            },
            {   enumValue: 'MOR',
                name: 'Morelos',
            },
            {   enumValue: 'NAY',
                name: 'Nayarit',
            },
            {   enumValue: 'NLE',
                name: 'Nuevo León',
            },
            {   enumValue: 'OAX',
                name: 'Oaxaca',
            },
            {   enumValue: 'PUE',
                name: 'Puebla',
            },
            {   enumValue: 'QUE',
                name: 'Querétaro',
            },
            {   enumValue: 'ROO',
                name: 'Quintana Roo',
            },
            {   enumValue: 'SLP',
                name: 'San Luis Potosí',
            },
            {   enumValue: 'SIN',
                name: 'Sinaloa',
            },
            {   enumValue: 'SON',
                name: 'Sonora',
            },
            {   enumValue: 'TAB',
                name: 'Tabasco',
            },
            {   enumValue: 'TAM',
                name: 'Tamaulipas',
            },
            {   enumValue: 'TLA',
                name: 'Tlaxcala',
            },
            {   enumValue: 'VER',
                name: 'Veracruz',
            },
            {   enumValue: 'YUC',
                name: 'Yucatán',
            },
            {   enumValue: 'ZAC',
                name: 'Zacatecas',
            },
        ],

        timeZones: () => [
            {   enumValue: 'UTC',
                name: 'UTC (Universal Coordinated Time)',
            },
            {   enumValue: 'ATLANTIC_STANDARD_TIME_CANADA',
                name: 'Atlantic (Canada)',
            },
            {   enumValue: 'EASTERN_STANDARD_TIME_US_CANADA',
                name: 'Eastern (US & Canada)',
            },
            {   enumValue: 'EASTERN_STANDARD_TIME_INDIANA_EAST',
                name: 'Eastern (Indiana)',
            },
            {   enumValue: 'CENTRAL_STANDARD_TIME_US_CANADA',
                name: 'Central (US & Canada)',
            },
            {   enumValue: 'CENTRAL_STANDARD_TIME_SASKATCHEWAN',
                name: 'Central (Saskatchewan)',
            },
            {   enumValue: 'CENTRAL_STANDARD_TIME_MEXICO',
                name: 'Central (Mexico)',
            },
            {   enumValue: 'MOUNTAIN_STANDARD_TIME_US_CANADA',
                name: 'Mountain (US & Canada)',
            },
            {   enumValue: 'MOUNTAIN_STANDARD_TIME_ARIZONA',
                name: 'Mountain (Arizona)',
            },
            {   enumValue: 'MOUNTAIN_STANDARD_TIME_MEXICO',
                name: 'Mountain (Mexico)',
            },
            {   enumValue: 'PACIFIC_STANDARD_TIME_US_CANADA',
                name: 'Pacific (US & Canada)',
            },
            {   enumValue: 'PACIFIC_STANDARD_TIME_MEXICO',
                name: 'Pacific (Mexico)',
            },
            {   enumValue: 'ALASKAN_STANDARD_TIME',
                name: 'Alaskan',
            },
            {   enumValue: 'HAWAIIAN_STANDARD_TIME',
                name: 'Hawaiian',
            },
        ],

        unitTypes: () => [
            {   enumValue: 'METRIC',
                name: 'Metric',
            },
            {   enumValue: 'IMPERIAL',
                name: 'American Customary Units',
            },
        ],

        volumeUnits: () => [
            {   enumValue: 'METRIC',
                name: 'Liters',
            },
            {   enumValue: 'IMPERIAL',
                name: 'Gallons',
            },
        ],

        weightUnits: () => [
            {   enumValue: 'KILOGRAMS',
                name: 'Kilograms',
            },
            {   enumValue: 'POUNDS',
                name: 'Pounds',
            },
        ],
    },
};
